const { log } = console
import API from '@/assets/js/libs/API'
import longTermCareService from '@/API/longTermCareService'
import { counties } from '@/mocks/index.js'
import {
  getAddressInfoArray,
  getIntersectionInfoArray,
} from '@/assets/js/tool/addressUtils'

const parse = (_arr) => _arr.map((i) => ({ value: i.address, geo: i }))
export default {
  data() {
    return { counties, addresses: [], addressDetail: [] }
  },
  methods: {
    async fillUserAddressGps(next) {
      let { address, gps, id } = this.selectedUser
      // 沒有GPS則不用把資料放上去
      if (!gps) {
        gps = [0, 0]
      }
      let gpsModfiy = {
        coordinates: gps,
      }
      next({ geo: { address, gps: gpsModfiy } })
    },
    landmarkSearchAsync(queryString, cb) {
      API.get(
        `landmark/gethailinglist/?key=${queryString.replace(
          /[ ]/g,
          '+',
        )}&isSupportOffice=false`,
      )
        .then((res) => {
          if (res.result === 'err') {
          } else {
            // this.landmark = res.result.landmarkInfo;
            // console.log('res.result.landmarkInfo', res.result.landmarkInfo)
            let landmark = []
            let lanmarkInfo = res.result.landmarkInfo
            for (let i = 0; i < lanmarkInfo.length; i++) {
              landmark.push({
                value: `${lanmarkInfo[i].name}-${lanmarkInfo[i].address}`,
                addressGPS: lanmarkInfo[i].addressGPS,
              })
            }
            cb(landmark)
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    handleTypeIn(keyword = '', next) {
      return keyword.length > 5 ? this.onChange(keyword, next) : next([])
    },
    autoSearchAddress() {
      var displaySuggestions = (predictions, status) => {
        if (status != google.maps.places.PlacesServiceStatus.OK) {
          alert(status)
          return
        }
        this.googleArray = []
        predictions.forEach((prediction) => {
          let address
          if (prediction.description.indexOf('台灣') === 0) {
            address = prediction.description.replace('台灣', '')
          }
          this.googleArray.push({
            address: address,
            id: prediction.place_id,
            gps: {
              coordinates: [0, 0],
              type: 'Point',
            },
          })
        })
        this.cb(parse(this.googleArray))
      }
      this.service.getPlacePredictions(
        { input: this.address },
        displaySuggestions,
      )
    },
    clickGoogleSearch(id, address) {
      this.geocoder.geocode(
        {
          placeId: id,
        },
        (responses, status) => {
          if (status == 'OK') {
            // console.log(responses)
            var lat = responses[0].geometry.location.lat()
            var lng = responses[0].geometry.location.lng()
            this.query = address
            let removedAddressKey = responses[0].formatted_address
              .trim()
              .replace(/\s/, '')
              .replace(/^\d+/, '')
            if (removedAddressKey.slice(0, 2) === '台灣') {
              removedAddressKey = removedAddressKey.slice(
                2,
                removedAddressKey.length,
              )
            }
            let object = {
              gps: [lng, lat],
            }
            let isRepeat = address.includes(removedAddressKey)
            if (isRepeat) {
              object.address = address
            } else {
              object.address = removedAddressKey + '(' + address + ')'
            }
            this.query = object.address
            const _lookup = {
              offLocation: 'offLocationGps', // 長照單下車
              onLocation: 'onLocationGps', // 長照單上車
              address: 'gps', // 長照用戶地址
            }
            this.$set(this.formData, this.field, object.address)
            this.$set(this.formData, _lookup[this.field], object.gps)
          }
        },
      )
    },
    handleLandmarkLocation(field, selected) {
      this.field = field
      const _lookup = {
        offLocation: 'offLocationGps', // 長照單下車
        onLocation: 'onLocationGps', // 長照單上車
        address: 'gps', // 長照用戶地址
      }
      this.$set(this.formData, field, selected.value)
      this.$set(this.formData, _lookup[field], selected.addressGPS.coordinates)
    },
    handleLocation(field, selected) {
      console.log('handleLocation', field)
      console.log('handleLocation-selected', selected)
      this.field = field
      if (selected.geo.id !== undefined) {
        console.log('selected.geo.id !== undefined')
        this.clickGoogleSearch(selected.geo.id, selected.value)
        return
      }
      if (selected.value === 'Google 搜尋') {
        this.autoSearchAddress()
        this.formData[field] = this.address
        return
      }
      const _lookup = {
        offLocation: 'offLocationGps', // 長照單下車
        onLocation: 'onLocationGps', // 長照單上車
        address: 'gps', // 長照用戶地址
      }

      if (!_lookup[field]) return this.$message.error('invalid field')
      const { geo: { address, gps } = {} } = selected

      this.$set(this.formData, field, address)
      this.$set(this.formData, _lookup[field], gps.coordinates)
    },
    onChange(value, cb) {
      this.address = value
      this.cb = cb
      // console.log(this.address)
      value = value || ''
      const address = value.trim().replace(/[ ]/g, '+')
      const intersection = address.replace('市', '市 ').replace(/[ ]/g, '+')
      const road = intersection.split('+').slice(1, 2).join('+')
      const { value: countyCode } =
        this.counties.find(
          (item) => intersection.indexOf(item.country) !== -1,
        ) || {}

      if (address.indexOf('+') === -1) {
        return this.getAddresList(value, cb)
      }
      API.get(`intersectionInfo/?key=${road}&county_number=${countyCode}`)
        .then((res) => res.result)
        .then((result) => {
          // console.log('result', result)
          if (result === 'err') return
          const [addresses, addressDetail] = getIntersectionInfoArray(
            result.intersectionInfo,
          )
          this.addresses = addresses
          this.addressDetail = addressDetail

          cb(parse(result.addressArray))
        })
        .catch((err) => {
          log('intersectionInfo', err)
        })
    },
    getAddresList(addr, cb) {
      const address = addr.replace(/\(.*?\)/g, '')
      this.addresses = ['Google搜尋']
      this.addressDetail = [{ address: 'Google搜尋', gps: [0, 0] }]

      API.get(`/search/address/v2/?address=${address}`)
        .then((data) => data.result)
        .then((result) => {
          if (result === '找不到該地址') {
            let array = [
              {
                address: 'Google 搜尋',
                gps: {
                  coordinates: [0, 0],
                  type: 'Point',
                },
              },
            ]
            cb(parse(array))
            return this.$message.error('找不到該地址') // 是否只剩區域剩一個
          }
          if (!result.cityDistrictRoad) {
            return this.$message.error(result)
          }
          const [addresses, addressDetail] = getAddressInfoArray(
            result.addressArray,
          )
          this.addresses = this.addresses.concat(addresses)
          this.addressDetail = this.addressDetail.concat(addressDetail)

          if (result.cityDistrictRoad.length !== 1) {
            this.addresses = this.addresses.concat(result.cityDistrictRoad)
          }
          let array2 = [
            {
              address: 'Google 搜尋',
              gps: {
                coordinates: [0, 0],
                type: 'Point',
              },
            },
          ]
          let array = array2.concat(result.addressArray)
          cb(parse(array))
        })
        .catch((err) => log('addressList', err))
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/longTermCare/_CoordinatePositioning.js